import initmixin from "@/Services/initmixin";

export default {
    DASHBOARD_ORDENES_COMPRA: async function(data) {
        let url = `/reportes-nuevos/dashboard-ordenes-compra?fecha_inicio=${data.fecha_inicio}&fecha_fin=${data.fecha_fin}`;
        return initmixin.formatrespuesta('get', {}, url, true);
    },
    DASHBOARD_PRODUCTOS: async function(data) {
        let url = `/reportes-nuevos/dashboard-productos?fecha_inicio=${data.fecha_inicio}&fecha_fin=${data.fecha_fin}`;
        return initmixin.formatrespuesta('get', {}, url, true);
    },
    REPORTE_GARANTIAS: async function(data) {
        let url = `/reportes-nuevos/reporte-garantias?fecha_inicio=${data.fecha_inicio}&fecha_fin=${data.fecha_fin}`;
        return initmixin.formatrespuesta('get', {}, url, true);
    },
    CALENDARIO_GARANTIAS: async function(data) {
        let url = `/reportes-nuevos/calendario-garantias?fecha_inicio=${data.fecha_inicio}&fecha_fin=${data.fecha_fin}`;
        return initmixin.formatrespuesta('get', {}, url, true);
    },
    INGRESOS_METODO_PAGO: async function(data) {
        let url = `/reportes-nuevos/ingresos-metodo-pago?fecha_inicio=${data.fecha_inicio}&fecha_fin=${data.fecha_fin}`;
        return initmixin.formatrespuesta('get', {}, url, true);
    },
    REPORTE_TIPO_CONTACTO: async function(data) {
        let url = `/reportes-nuevos/reporte-tipo-contacto?fecha_inicio=${data.fecha_inicio}&fecha_fin=${data.fecha_fin}`;
        return initmixin.formatrespuesta('get', {}, url, true);
    },
    DASHBOARD_PRODUCCION_INSTALACION: async function(data) {
        let url = `/reportes-nuevos/dashboard-produccion-instalacion?fechaInicio=${data.fechaInicio}&fechaFin=${data.fechaFin}`;
        if (data.comparar !== undefined) {
            url += `&comparar=${data.comparar ? '1' : '0'}`;
        }
        return initmixin.formatrespuesta('get', {}, url, true);
    },
};
